import { Case } from 'types/case'
import get from 'lodash/get'
import { cleanAndValidateFirstLetterText } from 'utils/tinyMCE/firstLetterTextCleaning'

export const extractFirstLetterFromKey = (
  path: string,
  initialText: string,
  caseDetails: Case,
) => {
  if (path?.startsWith('first_letter_')) {
    const originalFieldKey = path.replace('first_letter_', '')
    const originalValue = get(caseDetails, originalFieldKey)

    const { isValid, firstLetter } =
      cleanAndValidateFirstLetterText(originalValue)

    if (isValid && firstLetter) {
      return { path, value: firstLetter, initialText, type: 'string' }
    }

    return { path, value: '\u200A', initialText, type: 'empty' }
  }
  return null
}
